module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-vip-2.edb8ce13.png";